import { connect } from 'react-redux';

import { selectMetricDataFromCacheForContentItem } from '../../selectors/MetricDataCacheSelector';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { MetricCard, MetricCardOwnProps, MetricCardStateProps } from './MetricCard';


const mapStateToProps: MapStateToProps<MetricCardStateProps> = (state: AppState, ownProps: MetricCardOwnProps) => {
  return {
    metricData: selectMetricDataFromCacheForContentItem(state, ownProps.content)
  };
};

export const ConnectedMetricCard: React.ComponentClass<MetricCardOwnProps> = connect(mapStateToProps, undefined)(MetricCard);
